import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const Tile = ({ item, size = '' }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  const onEnter = () => {
    if (ref.current) {
      ref.current.play()
        .then(() => setPlaying(true))
        .catch(() => {});
    }
  };
  const onLeave = () => {
    if (ref.current) {
      ref.current.pause();
      try { ref.current.currentTime = 0; } catch (e) {}
    }
    setPlaying(false);
  };

  const isVideo = item.type === 'video';
  const hasPoster = !!item.poster;

  return (
    <Link
      to="/portfolio"
      state={{ focus: item.id }}
      className={`v2-showcase__tile ${size}`}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      aria-label={`View ${item.title}`}
    >
      {item.telemetry && <span className="v2-telemetry">{item.telemetry}</span>}
      {isVideo && hasPoster && (
        <img
          src={item.poster}
          alt=""
          loading="lazy"
          className="v2-showcase__poster"
          aria-hidden="true"
        />
      )}
      {isVideo ? (
        <video
          ref={ref}
          src={item.src}
          muted
          loop
          playsInline
          preload="none"
          className={`v2-showcase__video ${playing ? 'is-playing' : ''} ${hasPoster ? 'has-poster' : ''}`}
          aria-hidden="true"
        />
      ) : (
        <img src={item.src} alt={item.title} loading="lazy" />
      )}
      <div className="v2-showcase__caption">
        <div>
          <span>{item.category}</span>
          <h3>{item.title}</h3>
        </div>
        {item.tag && <span className="v2-showcase__tag">{item.tag}</span>}
      </div>
    </Link>
  );
};

export default Tile;
